var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-input-group',{attrs:{"prepend":"Ordenar de:"}},[_c('b-form-select',{attrs:{"options":_vm.options},model:{value:(_vm.orden),callback:function ($$v) {_vm.orden=$$v},expression:"orden"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }